export default __webpack_public_path__ + "asset/img/icon-like~af24c0a1.png";